import { token } from '@atlaskit/tokens';
import { legacyColors as colors } from '@databases/utils/legacy-colors';
import styled from 'styled-components';

const SELECTED_BORDER_WIDTH = 2;
export const VISUAL_REFRESH_TABLE_BORDER_RADIUS = token('radius.xlarge', '12px');
export const TABLE_BORDER_RADIUS = '3px'; // same radius as the Atlaskit input fields

export const selectedBorder = `${SELECTED_BORDER_WIDTH}px solid ${colors.B100}`;

export const visualRefreshSelectBorder = `${SELECTED_BORDER_WIDTH}px solid ${token(
  'color.border.selected'
)}`;
export const selectedBorderHoverDelete = `${SELECTED_BORDER_WIDTH}px solid ${token(
  'color.border.danger'
)}`;
export const invisibleBorder = `${SELECTED_BORDER_WIDTH}px solid transparent`;

export const DatabaseValueViewContainer = styled.span`
  display: inline-flex;
  max-width: 100%;
  flex-wrap: wrap;
  width: 100%;
`;
